import { memo } from "react";
import { VehiclesWidgetProps } from "./types";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import VehicleSearchTab from "./components/VehicleSearchTab/VehicleSearchTab";
import VehicleStatsTab from "./components/VehicleStatsTab/VehicleStatsTab";

const VehiclesWidget: React.FC<VehiclesWidgetProps> = () => {
  const { t } = useTranslate();


  return (
    <>
      <Tabs
        tabs={[
          {
            label: t("admin.dashboard.widget.vehicles.tab.stats.title"),
            content:
              <div >
                <VehicleStatsTab />
              </div>,
          },
          {
            label: t("admin.dashboard.widget.vehicles.tab.search.title"),
            content:
              <div >
                <VehicleSearchTab />
              </div>,
          },

        ]}
      />
    </>
  );
};

export default memo(VehiclesWidget);
